import { DeepMap, FieldError } from 'react-hook-form/dist/index.ie11';

export enum ValidationStatus {
    INVALID = 'invalid',
    VALID = 'valid',
    UNKNOWN = 'unknown'
}

export interface ValidationDecoration {
    <T>(
        field: Extract<keyof T, string>,
        errors: DeepMap<T, FieldError>,
        touchedFields: DeepMap<T, true>
    ): ValidationStatus;
}

const validationDecoration: ValidationDecoration = (
    field,
    errors,
    touchedFields
) => {
    if (Object.keys(errors).includes(field)) {
        return ValidationStatus.INVALID;
    }
    if (Object.keys(touchedFields).includes(field)) {
        return ValidationStatus.VALID;
    }
    return ValidationStatus.UNKNOWN;
};

export const getValidationStatus = (error: string) => {
    if (error) {
        return ValidationStatus.INVALID;
    }

    return ValidationStatus.UNKNOWN;
};

export default validationDecoration;
